import { useState } from "react";
import { useGame } from "../../app/GameProvider.js";
import { getCard } from "../../content/lookups.js";
import { cardKindLabel } from "../../components/cardFrame.js";
import type { CardInstance } from "../../domain/types/index.js";
import { ChoiceHead } from "../shared/ChoiceHead.js";

type GroupedCard = { cardId: string; name: string; count: number; first: CardInstance };

function groupCards(cards: CardInstance[]): GroupedCard[] {
  const groups = new Map<string, GroupedCard>();
  for (const card of cards) {
    const name = getCard(card.cardId)?.name ?? card.cardId;
    const existing = groups.get(card.cardId);
    if (existing) {
      existing.count += 1;
    } else {
      groups.set(card.cardId, { cardId: card.cardId, name, count: 1, first: card });
    }
  }
  return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name, "ja"));
}

function RemoveMode({ cards }: { cards: CardInstance[] }) {
  const { dispatch } = useGame();
  const [selected, setSelected] = useState<string | null>(null);
  const groups = groupCards(cards);

  return (
    <>
      <p style={{ color: "var(--muted)" }}>除去するカードを1枚選んでください。</p>
      <ul style={{ maxHeight: 240, overflowY: "auto", textAlign: "left", padding: 0 }}>
        {groups.map((g) => {
          const definition = getCard(g.cardId);
          return (
            <li key={g.cardId} style={{ listStyle: "none", marginBottom: 6 }}>
              <button
                type="button"
                className={`btn rest-remove-card ${selected === g.first.instanceId ? "is-selected" : ""}`}
                style={{ width: "100%" }}
                aria-pressed={selected === g.first.instanceId}
                onClick={() => setSelected(g.first.instanceId)}
              >
                <strong>{g.name} × {g.count}</strong>
                {definition && <span>{cardKindLabel(definition)}：{definition.text}</span>}
              </button>
            </li>
          );
        })}
      </ul>
      <button
        type="button"
        className="btn btn-danger"
        disabled={!selected}
        onClick={() => selected && dispatch({ type: "REST_REMOVE", instanceId: selected })}
      >
        このカードを除去する
      </button>
    </>
  );
}

export function RestScreen() {
  const { state, dispatch } = useGame();
  const [mode, setMode] = useState<"choose" | "remove">("choose");
  const run = state.run;
  if (!run) return null;

  const after = Math.max(0, run.fatigue - 3);

  return (
    <section className="screen screen-rest">
      <ChoiceHead kicker="REST" title="休日" />
      {mode === "choose" ? (
        <>
          <p style={{ color: "var(--muted)" }}>休むと全社疲労が 3 減る。</p>
          <p className="hero-num">
            <span style={{ color: "var(--fatigue)" }}>{run.fatigue}</span>
            {" → "}
            <span style={{ color: "var(--progress)" }}>{after}</span>
          </p>
          <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "TAKE_REST" })}>
            休む
          </button>
          <button type="button" className="btn" style={{ marginTop: 8 }} onClick={() => setMode("remove")}>
            カードを除去する
          </button>
        </>
      ) : (
        <>
          <RemoveMode cards={[...run.deck, ...run.discard]} />
          <button type="button" className="btn" style={{ marginTop: 8 }} onClick={() => setMode("choose")}>
            やめる
          </button>
        </>
      )}
    </section>
  );
}
